import { get } from 'services/client'

const fetchProcurementInfo = (locale = '') =>
  get(
    `procurements/profile`,
    locale && locale.length > 0 ? { 'Content-Language': locale } : {},
  )

export { fetchProcurementInfo }
